@if (isLoading()) {
  <mat-progress-bar
    class="esign-detail-progress"
    mode="indeterminate"
    [dataSelector]="'cxp-esign-detail-loading-bar'"
  ></mat-progress-bar>
}

<div class="esign-detail-grid">
  <main class="esign-detail-main">
    @if (request().hasDetail) {
      <cxp-deliverable-detail-header
        [name]="request().name ?? ''"
        [title]="pageTitle()"
        breadcrumbRootLabel="Tasks"
        [serviceLineName]="serviceLineName()"
        [clientName]="request().clientName"
        [description]="request().description"
      />

      @if (esign(); as detail) {
        <cxp-esign-signature-block
          [state]="detail.state"
          [filename]="detail.filename"
          [signedAt]="detail.signedAt"
          [signedFileUrl]="detail.signedFileUrl"
          [signers]="detail.signers"
          (reviewAndSign)="onReviewAndSign()"
          (viewDocument)="onViewDocument()"
        />
      } @else if (esignUnavailable()) {
        <!--
          The request is an eSign shell but the bundle behind it did not resolve —
          the caller holds no recipient row, or the eSign read failed. The header
          still describes the request, so this replaces the block rather than the page.
        -->
        <p class="esign-detail-status" [dataSelector]="'cxp-esign-detail-unavailable'">
          {{ esignUnavailableMessage() }}
        </p>
      }
    } @else if (request().hasError) {
      <p class="esign-detail-status esign-detail-status--error" [dataSelector]="'cxp-esign-detail-error'">
        We couldn't load this request. Please refresh and try again.
      </p>
    }
  </main>

  <aside class="esign-detail-rail">
    @if (request().hasDetail) {
      <cxp-crl-right-rail [team]="request().team" [clientContacts]="request().clientContacts" />
    }
  </aside>
</div>
